import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import Loader from 'components/common/Loader'
import IncognitoError from 'components/ControlBar2.0/TopControlBar/LeftControls/components/Jeopardy/IncognitoError'
import { isIncognito } from 'helpers/miscellaneous'
import { _iframeShareUrl } from 'store/selectors/WebSocket'
import { logger } from 'utils/logger'

import * as Styles from './styles'

const IframeShare = ({ isTeacher }) => {
    const [isLoading, setLoading] = useState(true)
    const iframeShareUrl = useSelector(_iframeShareUrl)
    const displayUrl = isTeacher
        ? iframeShareUrl?.teacher_url
        : iframeShareUrl?.student_url
    const isStimulation =
        iframeShareUrl?.student_url === iframeShareUrl?.teacher_url

    const [showErrorModal, setShowErrorModal] = useState(false)
    const openErrorModal = () => setShowErrorModal(true)
    const closeErrorModal = () => setShowErrorModal(false)

    useEffect(() => {
        if (isTeacher || isStimulation) return
        ;(async () => {
            if (await isIncognito()) {
                return openErrorModal()
            }
            try {
                await axios.get(iframeShareUrl?.student_url)
            } catch (error) {
                logger.error(`Jeopardy error: ${error}`)
            }
        })()
    }, [isTeacher, isStimulation])

    const handleIframeLoad = () => setLoading(false)

    return (
        <>
            <Styles.Container>
                {isLoading && <Loader />}
                <Styles.StyledIframe
                    src={displayUrl}
                    onLoad={handleIframeLoad}
                />
            </Styles.Container>
            <IncognitoError
                isModalOpen={showErrorModal}
                onCloseModal={closeErrorModal}
            />
        </>
    )
}

export default React.memo(IframeShare)
